import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Introduction.css';

const Introduction = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div className="introduction-container">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">测试介绍</h1>
        </div>

        <div className="page-content">
          <div className="intro-section">
            <h2>关于依恋型人格测试</h2>
            <p>
              依恋型人格测试帮助你了解在亲密关系中的情感模式，揭示你在恋爱或婚姻中的行为倾向。
              测试基于心理学依恋理论，测量'依恋焦虑'（担心被拒绝）和'依恋回避'（抗拒亲密）两个维度，
              得出四种依恋类型：安全型、焦虑型、回避型、恐惧型。
            </p>
          </div>

          <div className="versions-section">
            <h2>测试版本</h2>
            <div className="version-cards">
              <div className="version-card">
                <h3>快速测试（12题）</h3>
                <p>耗时2-3分钟，适合快速了解依恋风格</p>
              </div>
              <div className="version-card">
                <h3>深度测试（36题）</h3>
                <p>耗时5-7分钟，提供详细分析和建议</p>
              </div>
            </div>
          </div>

          <div className="actions">
            <button className="btn btn-primary" onClick={goToHome}>
              开始测试
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
